const ISO_CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  TRY: '₺',
  RUB: '₽',
  INR: '₹',
  KRW: '₩',
  BRL: 'R$',
  CAD: 'CA$',
  AUD: 'A$',
  CHF: 'CHF',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  HUF: 'Ft',
  CZK: 'Kč',
  RON: 'lei',
  BGN: 'лв',
  HRK: 'kn',
  MXN: 'MX$',
  ZAR: 'R',
  NGN: '₦',
  ARS: 'AR$',
  CLP: 'CL$',
  PEN: 'S/',
  COP: 'CO$',
  THB: '฿',
  MYR: 'RM',
  SGD: 'S$',
  HKD: 'HK$',
  TWD: 'NT$',
  IDR: 'Rp',
  PHP: '₱',
  VND: '₫',
  PKR: '₨',
  BDT: '৳',
  LKR: '₨',
  NPR: '₨',
  AED: 'د.إ',
  SAR: '﷼',
  QAR: '﷼',
  KWD: 'د.ك',
  BHD: 'BD',
  OMR: '﷼',
  JOD: 'JD',
  ILS: '₪',
  EGP: 'E£',
  MAD: 'MAD',
  UAH: '₴',
  KZT: '₸',
  GEL: '₾',
  AMD: '֏',
  AZN: '₼',
  UZS: 'лв',
}

export const toCurrency = (currencyHex: string) => {
  if (!currencyHex) return ''

  // Convert HTML entity (e.g. &#36; → $)
  const fromEntity = currencyHex.replace(/&#([a-zA-Z0-9]+);/g, (_match, group1) => {
    return String.fromCharCode(parseInt('0' + group1))
  })

  // If the result looks like an ISO 4217 code (3 uppercase letters), map to symbol
  const trimmed = fromEntity.trim().toUpperCase()
  if (/^[A-Z]{3}$/.test(trimmed)) {
    return ISO_CURRENCY_SYMBOLS[trimmed] ?? fromEntity
  }

  return fromEntity
}
